import { type AllegatoRichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/allegatoRichiestaDTO.ts';
import { type UploadFile } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Costruisce l'`UploadFile` (antd) che rappresenta il riepilogo firmato a
 * partire dall'allegato restituito dal backend. Ritorna `null` se il riepilogo
 * non è ancora firmato o se l'allegato non è disponibile.
 */
export function useSignedSummaryFile(
  hasSignedSummary: boolean,
  attachment: AllegatoRichiestaDTO | null | undefined,
): UploadFile | null {
  const { t } = useTranslation();

  return useMemo<UploadFile | null>(() => {
    if (!(hasSignedSummary && attachment)) return null;

    const fileName =
      attachment.nomeFile ??
      t('riepilogo-firmato.documento-firmato', 'Riepilogo Firmato');

    return {
      uid: attachment.idFile ?? `signed-summary-${fileName}`,
      name: fileName,
      status: 'done',
    };
  }, [hasSignedSummary, attachment, t]);
}
